export enum RetentionResourceType {
  ROOM = 'room',
  SESSION = 'session',
  FILE = 'file',
}

export enum RetentionRuleType {
  TTL = 'ttl',
  EVENT = 'event',
}

export type EventRetentionRuleConfig = {
  name: string
}

export interface EventRetentionRule extends RetentionRule {
  config: EventRetentionRuleConfig
}

export type TTLRetentionRuleConfig = {
  value: number
  unit: string
}

export interface TTLRetentionRule extends RetentionRule {
  config: TTLRetentionRuleConfig
}

export type RoomRetentionConfig = {}

export type SessionRetentionConfig = {
  kind?: string | null
  source?: string | null
}

export type FileRetentionConfig = {
  kind?: string | null
}

export interface RoomRetention extends RetentionResource {
  config?: RoomRetentionConfig | null
}

export interface SessionRetention extends RetentionResource {
  config?: SessionRetentionConfig | null
}

export interface FileRetention extends RetentionResource {
  config?: FileRetentionConfig | null
}

export interface RetentionResource {
  type: RetentionResourceType
}

export interface RetentionRule {
  type: RetentionRuleType
}

export type RetentionPolicy = {
  id: string
  enterprise: boolean
  rule: RetentionRule
  resource: RetentionResource
  createdAt: string
  updatedAt: string
  isDefault: boolean
}
